import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { setNoIndex } from '../utils/seo';
/**
 * Catch-all route. Previously an unmatched URL rendered a blank page, which
 * search engines treat as a soft 404. This gives crawlers (and visitors) a real
 * page with working links, explicitly marked noindex.
 */
export function NotFoundPage() {
  useEffect(() => {
    document.title = "Page Not Found | Mike's Pro Detail";
    setNoIndex("This page doesn't exist. Explore mobile car detailing services from Mike's Pro Detail in Ventura County, or call (818) 381-9905.");
  }, []);
  return <main className="w-full bg-black text-white" data-id="element-1073" data-mp="3gs4lxuf7xh8h">
      <section className="pt-40 pb-24 px-4" data-id="element-1074" data-mp="3gqtg7p27pzeq">
        <div className="max-w-3xl mx-auto text-center" data-id="element-1075" data-mp="3brysc8pe1knr">
          <h1 className="text-4xl md:text-5xl font-black uppercase tracking-tight mb-6" data-id="element-1076" data-mp="3bqf8y98fqthr">
            <span className="bg-clip-text text-transparent bg-gradient-to-b from-yellow-300 via-yellow-400 to-yellow-500" data-id="element-1077" data-mp="1mdtvximw0h14">
              Page Not Found
            </span>
          </h1>
          <div className="h-1 w-24 bg-red-600 rounded-full shadow-[0_0_10px_rgba(220,38,38,0.8)] mx-auto mb-6" data-id="element-1078" data-mp="wdjzt5ksvue6" />
          <p className="text-lg text-gray-400 mb-10" data-id="element-1079" data-mp="10du32ah7k6pc">
            The page you're looking for doesn't exist. Head back home or explore
            our mobile detailing services.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-1080" data-mp="1a4yi1a6vvrk6">
            <Link to="/" className="px-8 py-4 bg-red-600 hover:bg-red-700 text-white font-bold text-lg uppercase tracking-wider rounded-sm transition-colors w-full sm:w-auto text-center" data-id="element-1081" data-mp="1f1oyhymlop64">
              Back to Home
            </Link>
            <Link to="/services" className="px-8 py-4 bg-white text-black hover:bg-gray-200 font-bold text-lg uppercase tracking-wider rounded-sm transition-colors w-full sm:w-auto text-center" data-id="element-1082" data-mp="1o1c1upyw451t">
              Our Services
            </Link>
          </div>
        </div>
      </section>
    </main>;
}